import { baseApi } from './baseApi';
import { Document } from '../../types';

export const documentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingDocuments: builder.query<Document[], string>({
      query: (ownerId) => `/print/pending/${ownerId}`,
      providesTags: ['Documents'],
    }),
    approveDocument: builder.mutation<
      { success: boolean; status: string },
      { id: string; approved: boolean }
    >({
      query: ({ id, approved }) => ({
        url: `/print/${id}/approve`,
        method: 'POST',
        body: { approved },
      }),
      invalidatesTags: ['Documents'],
    }),
    createPrintRequest: builder.mutation<
      { success: boolean; documentId: string; status: string },
      {
        fileKey: string;
        fileName: string;
        ownerId: string;
        qrSessionToken: string;
        userId: string;
        userName: string;
        userPhone?: string;
        color: 'bw' | 'color';
        paymentMethod: 'online' | 'cod';
        pageCount: number;
        paperSize?: string;
        paperType?: string;
        orientation?: 'portrait' | 'landscape';
        copies?: number;
        razorpayOrderId?: string;
        razorpayPaymentId?: string;
      }
    >({
      query: (body) => ({
        url: '/print/request',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Documents'],
    }),
  }),
});

export const {
  useGetPendingDocumentsQuery,
  useApproveDocumentMutation,
  useCreatePrintRequestMutation,
} = documentApi;
